import PropTypes from 'prop-types';
import { useEffect, useState, useCallback } from 'react';
import { Stack } from '@mui/material';
import { useParams, useLocation } from 'react-router-dom';
import { PATH_SETDEALER } from '../../routes/paths';
import CustomBreadcrumbs from '../../components/custom-breadcrumbs';

// ---------------------------------------------------------------------------------------------------------------

DealerHeader.propTypes = {
    headerName: PropTypes.string,
    breadcrumbsName: PropTypes.string,
};
// ---------------------------------------------------------------------------------------------------------

export default function DealerHeader({ headerName, breadcrumbsName }) {
    const location = useLocation();
    const path = location.pathname.split('/')[1];


    return (
        <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' mb={1} height={56}>
           <CustomBreadcrumbs
                heading={headerName}
                links={[
                    {
                        name: headerName, href: PATH_SETDEALER.dealer.maindealerpage
                    },
                    {
                        name: breadcrumbsName
                    },
                    {
                        name: "Create",
                    },
                ]}
            />
        </Stack>
    );
}